export default __webpack_public_path__ + "static/media/all_activity.a91b6af1.svg";